export const fatorArredondamentoSectionKeys = [
    "calculoFatorJuros",
    "casasFatorJuros",
    "calculoJuros",
    "casasJuros",
    "calculoFatorCorrecao",
    "casasFatorCorrecao",
    "calculoCorrecao",
    "casasCorrecao",
    "calculoFatorJurosCDI",
    "casasFatorJurosCDI",
    "calculoVNA",
    "casasVNA",
    "calculoFatorDesconto",
    "casasFatorDesconto",
    "calculoFatorExpectativa",
    "casasFatorExpectativa",
    "calculoPU",
    "casasPU",
]